
export default {

    set_loading(state, value) {
        state.loading=value
    },

    set_loading_empty(state, value) {
        state.loadingEmpty=value
    },

    set_list(state, value) {
        state.list=value
    },

    set_empty_list(state, value) {
        state.empty=value
    }
}